<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="2" y="2" width="4" height="12" fill="currentColor"/>
<rect x="1.5" y="1.5" width="13" height="13" stroke="currentColor"/>
<path d="M6.5 1.5V14.5" stroke="currentColor"/>
</svg>
